import "./StainlessSteel.module.css";
import Header from "@/reusable_sections/Header";
import Directanswerblock from "./sections/Directanswerblock";
import Whatisstainlesssteel from "./sections/Whatisstainlesssteel";
import Stainlessproperties from "./sections/Stainlessproperties";
import Stockfinishes from "./sections/Stockfinishes";
import Whentochoosestainless from "./sections/Whentochoosestainless";
import Wherestainlessisused from "./sections/Wherestainlessisused";
import Faqaccordion from "./sections/Faqaccordion";
import Closingcta from "./sections/Closingcta";
import Footer from "@/reusable_sections/Footer";
export default function StainlessSteelPage() {
  return <div>
      <Header />
      <Directanswerblock />
      <Whatisstainlesssteel />
      <Stainlessproperties />
      <Stockfinishes />
      <Whentochoosestainless />
      <Wherestainlessisused />
      <Faqaccordion />
      <Closingcta />
      <Footer />
    </div>;
}